import { render, staticRenderFns } from "./SchemeView.vue?vue&type=template&id=6dea1d50&scoped=true&"
import script from "./SchemeView.vue?vue&type=script&lang=js&"
export * from "./SchemeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea1d50",
  null
  
)

export default component.exports